import { useMemo } from 'react'

export default function useEmailTruncation (email: string | undefined) {
  const truncated = useMemo(() => {
    if (!email) {
      return undefined
    }
    const split = email?.split('@')
    const truncatedUsername = split?.[0].slice(0, 6)
    const truncatedDomain = split?.[1].slice(0, 6)

    // It looks weird to have a dot preceding the ellipsis
    // TODO: Update this to truncatedUsername.at(-1) when we update Node
    const trimmedUsername = truncatedUsername[truncatedUsername.length - 1] === '.' ? truncatedUsername.slice(0, -1) : truncatedUsername
    const trimmedDomain = truncatedDomain[truncatedDomain.length - 1] === '.' ? truncatedDomain.slice(0, -1) : truncatedDomain

    const truncated = (
      <>{trimmedUsername}&hellip;@{trimmedDomain}&hellip;</>
    )

    return truncated
  }, [email])
  return { original: email, truncated }
}
